import React from 'react';

import { SelectorListItem } from '../../../../../types/store/selector-list-item';

const DRMSelector = ({
  selectorList,
  addToCart,
}: {
  selectorList: SelectorListItem[];
  addToCart: (sku: string) => void;
}) => {
  const onSelect =
    (drmName?: string) =>
    async (event: React.SyntheticEvent<HTMLSelectElement | HTMLLIElement>) => {
      const value = drmName || (event.target as any).value;
      const item = selectorList.find(({ name }) => name === value);
      if (!item) {
        return;
      }
      await addToCart(item.sku);
    };

  const handleClick = (drmName) => onSelect(drmName);

  return (
    <>
      <ul className='store__drm-list' data-drm-selector>
        {selectorList.map(({ name, sku, realPrice }) => (
          <li key={sku} className='store__drm-item' onClick={handleClick(name)}>
            <span className='store__drm-name'>{name}</span>{' '}
            <span>{realPrice}</span>
          </li>
        ))}
      </ul>
      <select
        className='store__drm-native-select'
        data-drm-native-selector
        onChange={onSelect()}
      >
        <option value=''>--</option>
        {selectorList.map(({ name, sku, realPrice }) => (
          <option key={sku} value={name}>
            {name} {realPrice}
          </option>
        ))}
      </select>
    </>
  );
};

export default DRMSelector;
